import { InfoDisplayField } from './InfoDisplayField';
import { useAvgMonthlyPaymentField } from './hooks/useAvgMonthlyPaymentField';

export const AvgMonthlyPaymentField = () => {
    const { label, value } = useAvgMonthlyPaymentField();

    return <InfoDisplayField label={label} value={value} />;
};
